import React from 'react';
import { format } from 'date-fns';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import Icon from '@ant-design/icons';
import { DATE_FORMAT, DATE_ONLY_MONTH_FORMAT } from 'src/constants/index';
import { formatDateCheckInOut, getSelectedMonthText } from 'src/utils/index';
import { LocationGreySvg, CondoSvg } from 'src/assets/index';
import {
  CondoLocationsEnum,
  SearchHandlerArgs,
  ICondoRecentSearches,
} from 'src/common-types/index';
import './style.scss';

interface IProps extends WrappedComponentProps {
  data: ICondoRecentSearches;
  onSearchHandler: SearchHandlerArgs;
}

const ONE = 1;

class CondoRecentSearchesComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { data, onSearchHandler, intl } = this.props;
    const {
      months,
      checkIn,
      checkOut,
      location,
      searchType,
      adultsCount,
      stayDuration,
      childrenCount,
      bedroomsCount,
      isPetsAllowed,
    } = data;
    const guestsInfo = {
      adultsCount,
      bedroomsCount,
      kidsCount: childrenCount,
      petsAllowed: isPetsAllowed,
    };

    const isGenericRegion = location.locationType === CondoLocationsEnum.GenericRegion;
    const formattedMonths = months?.map((month) => format(new Date(month), DATE_FORMAT));
    const formattedStartDate = checkIn && formatDateCheckInOut(checkIn, DATE_ONLY_MONTH_FORMAT);
    const formattedEndDate = checkOut && formatDateCheckInOut(checkOut, DATE_FORMAT);

    return (
      <div
        role="button"
        className="recent-searches-picker"
        onClick={() =>
          onSearchHandler(
            location,
            searchType,
            stayDuration,
            guestsInfo,
            formattedMonths,
            checkIn,
            checkOut,
          )
        }
      >
        <Icon component={isGenericRegion ? LocationGreySvg : CondoSvg} />
        <div className="recent-searches-picker__info">
          <p className="recent-searches-picker__title">{location.name + (!location.region ? '' : ', ' + location.region)}</p>
          <p className="recent-searches-picker__subtitle ttl">
            {checkIn ? (
              <span>
                {formattedStartDate} - {formattedEndDate}
              </span>
            ) : (
              <>
                {ONE} <FormattedMessage id="week" values={{ count: ONE }} />{' '}
                {formattedMonths?.length ? (
                  <span>
                    <FormattedMessage id="in" /> {getSelectedMonthText(formattedMonths, intl)}
                  </span>
                ) : (
                  <span>
                    <FormattedMessage id="anytime" />
                  </span>
                )}
              </>
            )}
          </p>
          <p className="recent-searches-picker__subtitle">
            {adultsCount} <FormattedMessage id="adult" values={{ count: adultsCount }} />,{' '}
            {!!childrenCount && (
              <>
                {childrenCount} <FormattedMessage id="child" values={{ count: childrenCount }} />,{' '}
              </>
            )}
            {bedroomsCount} <FormattedMessage id="bedroom" values={{ count: bedroomsCount }} />
          </p>
        </div>
      </div>
    );
  }
}

export const CondoRecentSearches = injectIntl(CondoRecentSearchesComponent);
